import React, { memo } from "react";
import ReadonlyField from "./ReadonlyField";
import { PersonalDetailsData } from "../types";

interface PersonalDetailsProps {
  data?: PersonalDetailsData;
  nationalId?: string
}

const PersonalDetails: React.FC<PersonalDetailsProps> = ({ data, nationalId }) => {

 

  return (
    <div className="container mt-4">
      <div className="row">
        <ReadonlyField label="First Name" value={data?.firstName} />
        <ReadonlyField label="Middle Name" value={data?.middleName ?? "-"} />
        <ReadonlyField label="Last Name" value={data?.lastName} />
        {/* <ReadonlyField label="Family Name" value={data?.familyName} /> */}

        {/* <ReadonlyField label="First Name (Arabic)" value={data?.firstNameArabic} />
        <ReadonlyField label="Middle Name (Arabic)" value={data?.middleNameArabic} />
        <ReadonlyField label="Last Name (Arabic)" value={data?.lastNameArabic} />
        <ReadonlyField label="Family Name (Arabic)" value={data?.familyNameArabic} /> */}

        <ReadonlyField label="Date of Birth" value={data?.dateOfBirth} />
        {/* <ReadonlyField label="Date of Birth (H)" value={data?.dateOfBirthH} /> */}
        <ReadonlyField label="E-mail Address" value={data?.email} />
        <ReadonlyField label="Mobile Number" value={data?.mobileNumber} />

        <ReadonlyField label="Nationality" value={data?.nationality} />
        <ReadonlyField label="Nationality ID" value={nationalId} />
        <ReadonlyField
          label="Nationality ID Expiry Date"
          value={data?.idExpiry}
        />
      </div>
    </div>
  );
};

export default memo(PersonalDetails);